module.exports = __webpack_public_path__ + "img/stack04.6a282bae.svg";